module.exports = __webpack_public_path__ + "static/img/cz.2339f3df.svg";